import { h } from 'preact';
import * as BaseComp from 'components/bolt/home/home.js';
import { smoothScrollTo } from 'utils/smoothScroll';
import { accessNested } from 'utils/utils';
import s from 'components/bolt/home/home.sss';

export default class Home extends BaseComp.default {
	scrollToNext(e, time, force) {
		let scrollContainer = document.getElementById('mainScroll');
		let scrollTo = document.querySelector('.' + s.container).nextElementSibling;
		const isDesktop = accessNested(this.props, 'store.client.isDesktopSize', false);
		const scrollOffset = isDesktop ? -20 : 0;
		smoothScrollTo(scrollContainer, scrollTo, time || 300, { offset: scrollOffset, force });
	}
}
